import { render, staticRenderFns } from "./AddressSuggestionField.vue?vue&type=template&id=2d6862cc&scoped=true"
import script from "./AddressSuggestionField.vue?vue&type=script&lang=js"
export * from "./AddressSuggestionField.vue?vue&type=script&lang=js"
import style0 from "./AddressSuggestionField.vue?vue&type=style&index=0&id=2d6862cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6862cc",
  null
  
)

export default component.exports